module.exports = __webpack_public_path__ + "img/chat-conversation-dark.9bd21a2b.svg";